// Where every Leaflet map in the app gets its raster tiles.
//
// Production draws the public OpenStreetMap tiles, exactly as each map did
// when it hardcoded the URL. The test environment sets
// `config.x.map_tile_url`, which the layouts publish as
// <meta name="map-tile-url">, and every map reads that instead. Without it the
// system tests fetched live tiles from tile.openstreetmap.org; Leaflet adds its
// <img>s while the page is still loading, so a slow tile server held back the
// load event and `visit` died with Net::ReadTimeout under a full-suite run.
export const OSM_TILE_URL = "https://tile.openstreetmap.org/{z}/{x}/{y}.png"
export const OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'

export function tileUrl() {
    return document.querySelector('meta[name="map-tile-url"]')?.content || OSM_TILE_URL
}
